/* eslint-disable no-undef */
import React, { useEffect, useState, useRef } from "react";
import * as A from "../../css/login/login";
import { Container, Row, Col } from "react-bootstrap";
import {
  BtnLightYellow,
  BtnYellow,
} from "../../css/components/button/buttonYellow";
import CardButton from "../../componant/buttons/cardButton";
import {
  postNumbaLogin,
  postInsFcmToken,
  postNumbaRefresh,
} from "../../api/auth";
import { toast } from "wc-toast";
import { Link, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { headerText, userLoginJotai } from "../../App";
import { ClipLoader } from "react-spinners";
import Modal from "react-bootstrap/Modal";
import { scrollToTop } from "../../utils/hooks/scrollToTop";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { isMobile } from "react-device-detect";
import axios from "axios";
import config from "../../config";
import { messagingReady } from "../../firebase";
import { getToken } from "firebase/messaging";

export default function Login() {
  const navigate = useNavigate();
  const idRef = useRef(null);
  const isIOS = () => {
    return /iPad|iPhone|iPod|Mac/.test(navigator.userAgent) && !window.MSStream;
  };

  const access_token = localStorage.getItem("access_token");
  const refresh_token = localStorage.getItem("refresh_token");
  const [userLoginAtom, setUserLoginAtom] = useAtom(userLoginJotai);
  const [loginState, setLoginState] = useState({
    user_id: "",
    passwd: "",
    permission: "",
    isMobile: "",
  });
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [headerTextAtom, setHeaderTextAtom] = useAtom(headerText);
  const [isChecked, setIsChecked] = useState(false);
  const fcmFlagRef = useRef('');

  const VAPID_KEY =
    "BKokXX_v3DCmLuwnXBgQxxhS2EfWGiRndE0cria4kMhNT8K8_jruyZkvEKXIyj5cwOrgI9gjNOM1MNzAzB7G_qE";

  function detectPlatform() {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) return "aw";
    if (/iPhone|iPad|iPod/.test(ua)) return "iw";
    return "w";
  }

  const isAndroidApp = () =>
    typeof window !== "undefined" &&
    typeof window.TOPTOP_APP !== "undefined" &&
    typeof window.TOPTOP_APP.getFCMToken === "function";

  const isIOSApp = () =>
    typeof window !== "undefined" &&
    typeof window.webkit !== "undefined" &&
    typeof window.webkit.messageHandlers !== "undefined" &&
    typeof window.webkit.messageHandlers.getFCMToken !== "undefined";

  const isWebPushAllowed = () => {
    return !isAndroidApp() && !isIOSApp() && isMobile;
  };

  useEffect(() => {
    const initialize = async () => {
      if (access_token) {
        navigate("/");
        return;
      }
      if ((!refresh_token || refresh_token.trim() === "") && isMobile) {
        try {
          await refresh();
          return;
        } catch (error) {
          console.error("Token refresh failed:", error);
        }
      }

      scrollToTop();
      setHeaderTextAtom("로그인");
      idRef.current?.focus();

      const savedUserId = localStorage.getItem("user_id");
      if (savedUserId) {
        setLoginState((prevProps) => ({
          ...prevProps,
          user_id: savedUserId,
        }));
        setIsChecked(true);
      }
    };

    initialize();
  }, [access_token, refresh_token]);

  async function refresh() {
    try {
      const response = await axios({
        url: config.API_URL + "/auth/refreshAfterTimeOut",
        data: {},
        method: "post",
        withCredentials: true,
        headers: {
          Authorization: "",
        },
      });
      if (response.data.access_token) {
        const { access_token, refresh_token } = response.data;
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        if (window.location.pathname !== "/login") {
          navigate("/login");
        }
      } else {
        return;
      }
    } catch (err) {
      console.error("Failed to refresh token", err);
      return;
    }
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const trimValue = value.trim();
    setLoginState((prevProps) => ({
      ...prevProps,
      [name]: trimValue,
    }));
  };

  const handleCheckboxChange = async () => {
    setIsChecked(!isChecked);
  };

  const handleFCMToken = async (token) => {
    if (token) {
      await postInsFcmToken({ fcm_token: token, fcm_flag: fcmFlagRef.current })
        .then((res) => {
          console.log("fcmToken success >>> ", res?.message);
        })
        .catch((err) => {
          console.error('fcmToken fail >>>', err);
        });
    } else {
      console.log("fcmToken is invalid");
    }
  };

  // 전역 함수로 선언
  window.handleFCMToken = handleFCMToken;

  const handleLogin = async () => {
    if (/\s/.test(loginState.user_id)) {
      return toast.error("아이디에는 공백을 포함할 수 없습니다.");
    }
    if (loginState.user_id === "" || loginState.passwd === "") {
      return toast.error("아이디 또는 비밀번호를 입력 해 주세요.");
    }
    fcmFlagRef.current = '';
    try {
      setLoading(true);
      let permission = "";
      if (isWebPushAllowed()) {
        try {
          permission = await Notification.requestPermission();
          console.log('permission >>> ', permission);
        } catch (error) {
          console.log("error");
        }
      }

      const updatedLogin = {
        ...loginState,
        permission,
        isMobile,
      };
      setLoginState(updatedLogin);
      const response = await postNumbaLogin(updatedLogin);

      if (response?.code === 1000) {
        setUserLoginAtom(response);
        localStorage.setItem("access_token", response?.access_token);
        localStorage.setItem("refresh_token", response?.refresh_token);
        localStorage.setItem("device_id", response?.device_id);
        if (isChecked) {
          localStorage.setItem("user_id", loginState.user_id);
        } else {
          localStorage.removeItem("user_id");
        }

        // fcmToken 호출 - 앱 + 모바일 웹
        if (isAndroidApp()) {
          fcmFlagRef.current = 'a';
          window.TOPTOP_APP.getFCMToken("handleFCMToken");

        } else if (isIOSApp()) {
          fcmFlagRef.current = 'i';
          window.webkit.messageHandlers.getFCMToken.postMessage("handleFCMToken");

        } else if (isWebPushAllowed()) {
          fcmFlagRef.current = detectPlatform();
          if (permission !== "granted") return;

          if ("serviceWorker" in navigator) {
            const msg = await messagingReady;

            if (msg) {
              const token = await getToken(msg, {
                vapidKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
                serviceWorkerRegistration:
                  await navigator?.serviceWorker?.register(
                    "/firebase-messaging-sw.js"
                  ),
              });
              await handleFCMToken(token);
            } else {
              console.log("Firebase Messaging 미지원 환경 - FCM 토큰 생략");
            }
          } else {
            toast.error('IW : 앱푸시 지원하지 않음');
            console.log("Service Worker not supported in this environment");
          }
        }

        setTimeout(function () {
          navigate("/");
        }, 300);

      } else {
        console.log("로그인 실패");
      }
    } catch (err) {
      switch (err.code) {
        case -4:
          toast.error("탈퇴 회원입니다.");
          break;
        case -5:
          toast.error("아이디가 중지 상태입니다.");
          break;
        case -10:
          toast.error("아이디를 입력해주세요");
          break;
        case -11:
          toast.error("비밀번호를 입력해주세요");
          break;
        case -12:
          toast.error("아이디가 존재하지 않습니다.");
          break;
        case -13:
          toast.error("아이디 또는 비밀번호가 일치하지 않습니다.");
          break;
        case -14:
          alert(
            "로그인 10회 실패하였습니다. '비밀번호 찾기'를 통해 비밀번호를 재설정해주세요."
          );
          setTimeout(() => navigate("/find-password"), 300);
          break;
        default:
          console.error(err);
          break;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  // 카카오 로그인
  const KAKAO_URL =
    process.env.REACT_APP_KAKAO_HOST_URL +
    "redirect_uri=" +
    process.env.REACT_APP_KAKAO_REDIRECT_URL;

  return (
    <>
      <A.ContentWrapper_div>
        <Container>
          <div style={{ fontSize: 15, marginBottom: 30 }}>
            기존 회원이신 분들은{" "}
            <span
              onClick={() => handleNavigate("/find-password")}
              style={{ cursor: "pointer", color: "#FF9900", fontSize: 20 }}
            >
              비밀번호 찾기
            </span>
            를 눌러
            <br /> 비밀번호를 변경해주세요.
          </div>
          <Row>
            <Col md={12}>
              <A.bodyLogoBrand>
                <img src={process.env.PUBLIC_URL + "/img/logo.svg"} alt="" />
              </A.bodyLogoBrand>
              <A.LoginInput_Wrapper>
                <A.LoginInput
                  placeholder="아이디를 입력하세요"
                  name="user_id"
                  ref={idRef}
                  value={loginState?.user_id?.trim()}
                  onChange={handleInputChange}
                />
                <A.LoginInput
                  type="password"
                  placeholder="비밀번호를 입력하세요"
                  name="passwd"
                  onChange={handleInputChange}
                  onKeyPress={(e) => handleKeyPress(e)}
                />
                <BtnYellow onClick={() => handleLogin()} className="mt-3">
                  {loading ? (
                    <ClipLoader loading={true} color="#fff" size={23} />
                  ) : (
                    "로그인"
                  )}
                </BtnYellow>
                {/* <CardButton
                  width="330px"
                  bg="#FF9C00"
                  name="로그인"
                  className="btn-main mt-3"
                  onClick={() => handleLogin()}
                  loading={loading}
                ></CardButton> */}
                <div className="CustomCheckerBox">
                  <div className="mt-12">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onChange={handleCheckboxChange}
                      checked={isChecked}
                    />
                    <label
                      className="form-check-label f-medium"
                      htmlFor="inlineCheckbox7"
                    >
                      아이디 저장
                    </label>
                  </div>
                </div>
                {!isIOS() && (
                  <>
                    <div>
                      <A.LoginOr_Txt> 또는</A.LoginOr_Txt>
                    </div>
                    <a href={KAKAO_URL}>
                      <BtnLightYellow
                        color="#14090780"
                        className="position-relative"
                      >
                        <A.Message_icon
                          src={process.env.PUBLIC_URL + "/img/message_icon.svg"}
                          alt=""
                        />
                        카카오 로그인
                      </BtnLightYellow>
                    </a>
                  </>
                )}
                <A.login_SpanWrapper>
                  <A.Login_SpanOne className="pe-4">
                    <Link className="LoginLink" to={"/find-id"}>
                      아이디 찾기
                    </Link>
                  </A.Login_SpanOne>
                  <A.Login_SpanTwo className="ps-4">
                    <Link className="LoginLink" to={"/find-password"}>
                      비밀번호 찾기
                    </Link>
                  </A.Login_SpanTwo>
                </A.login_SpanWrapper>
                <A.LoginBottom_Para>
                  <div>
                    아직
                    <span className="red">TOP</span>
                    <span className="blue">TOP</span>
                    회원이 아니세요?
                  </div>
                </A.LoginBottom_Para>
                <A.LoginBottom_ParaYellow>
                  <Link className="LoginLink" to="/signup">
                    회원가입
                  </Link>
                </A.LoginBottom_ParaYellow>
              </A.LoginInput_Wrapper>
            </Col>
          </Row>
        </Container>
      </A.ContentWrapper_div>
    </>
  );
}
